<div class="loginscreen mtv-primary-bg-color-no-hover">
    <div class="login-container">
        <div class="login-inner">
            <form (ngSubmit)="submit()">
                <div class="logo"></div>
                <h4>Account Login</h4>
                <div [ngClass]="{'has-error': isError}" class="form-group">
                    <input [(ngModel)]="email" (input)="resetError()" type="text" name="email" class="form-control"
                           placeholder="Email" required maxlength="255" tabindex="1">
                </div>
                <div [ngClass]="{'has-error': isError}" class="form-group password-row">
                    <input [(ngModel)]="password" (input)="resetError()"
                           type="{{!showPassword ? 'password' : 'text'}}" name="password"
                           class="form-control" placeholder="Password" required maxlength="255" tabindex="2">
                    <i *ngIf="!showPassword" class="fa fa-eye" aria-hidden="true" (click)="showPassword = true"></i>
                    <i  *ngIf="showPassword" class="fa fa-eye-slash" aria-hidden="true" (click)="showPassword = false"></i>
                </div>
                <div class="text-right m-b-sm">
                    <label>
                        <a [href]="forgotPassLink" class="pull-right mtv-primary-color reset-password-link" tabindex="3">
                            Forgot password
                        </a>
                    </label>
                </div>
                <button type="submit" class="btn btn-primary block full-width m-b" tabindex="4">Log In</button>
                <div class="text-center clickable twelve-pixels-font">
                    Don't have an account? <a class="mtv-primary-color" [href]="requestAccessLink">Request Access</a>
                </div>
            </form>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/login/login.component.html